import { render, staticRenderFns } from "./CheckboxesRadios.vue?vue&type=template&id=6acfcff5&"
import script from "./CheckboxesRadios.vue?vue&type=script&lang=js&"
export * from "./CheckboxesRadios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports